import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { NotificationsProvider } from "@/contexts/NotificationsContext";
import AuthModal from "@/components/auth/AuthModal";
import NotificationsDrawer from "@/components/portal/notifications/NotificationsDrawer";

import LenisProvider from "@/components/motion/LenisProvider";
import BootSequence from "@/components/motion/BootSequence";
import CustomCursor from "@/components/primitives/CustomCursor";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/hero/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import ProblemSection from "@/components/sections/ProblemSection";
import AZSystem from "@/components/sections/AZSystem";
import GenesisHook from "@/components/sections/azsystem/GenesisHook";
import AccessGates from "@/components/sections/AccessGates";
import BuildPathAccess from "@/components/sections/BuildPathAccess";
import ExpansionModules from "@/components/sections/ExpansionModules";
import SmithersSection from "@/components/sections/SmithersSection";
import QBandSection from "@/components/sections/QBandSection";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

import OrderConfirmedPage from "@/pages/OrderConfirmedPage";
import PortalPage from "@/pages/PortalPage";
import ModuleWorkspace from "@/pages/ModuleWorkspace";
import Workspace from "@/pages/Workspace";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";

function Landing() {
    useEffect(() => {
        document.body.classList.add("has-custom-cursor");
        return () => document.body.classList.remove("has-custom-cursor");
    }, []);

    return (
        <div className="relative min-h-screen bg-tca-deep text-tca-ink overflow-x-hidden" data-testid="landing-root">
            <BootSequence />
            <CustomCursor />
            <Nav />
            <main>
                <Hero />
                <TrustStrip />
                <ProblemSection />
                <AZSystem />
                <GenesisHook />
                <AccessGates />
                <BuildPathAccess />
                <ExpansionModules />
                <SmithersSection />
                <QBandSection />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <NotificationsProvider>
                        <LenisProvider>
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/order-confirmed" element={<OrderConfirmedPage />} />
                                <Route path="/portal" element={<PortalPage />} />
                                <Route path="/portal/workspace" element={<Workspace />} />
                                <Route path="/portal/module/:letter" element={<ModuleWorkspace />} />
                                <Route path="/portal/projects" element={<Projects />} />
                                <Route path="/portal/projects/:id" element={<ProjectDetail />} />
                            </Routes>
                            <NotificationsDrawer />
                        </LenisProvider>
                    </NotificationsProvider>
                </BrowserRouter>
                <AuthModal />
                <Toaster
                    theme="dark"
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "rgba(8, 10, 14, 0.92)",
                            border: "1px solid rgba(0,219,255,0.22)",
                            color: "#E6EBF1",
                            backdropFilter: "blur(12px)",
                        },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;
